var map = {
	"./bg-pattern-footer-desktop.svg": 43,
	"./bg-pattern-footer-mobile.svg": 44,
	"./bg-pattern-how-we-work-desktop.svg": 45,
	"./bg-pattern-how-we-work-mobile.svg": 46,
	"./bg-pattern-intro-left-desktop.svg": 47,
	"./bg-pattern-intro-left-mobile.svg": 48,
	"./bg-pattern-intro-right-desktop.svg": 49,
	"./bg-pattern-intro-right-mobile.svg": 50,
	"./bg-pattern-mobile-nav.svg": 51,
	"./icon-affordable-prices.svg": 14,
	"./icon-close.svg": 15,
	"./icon-facebook.svg": 16,
	"./icon-hamburger.svg": 17,
	"./icon-instagram.svg": 18,
	"./icon-people-first.svg": 19,
	"./icon-pinterest.svg": 20,
	"./icon-snappy-process.svg": 21,
	"./icon-twitter.svg": 22,
	"./image-intro-desktop.jpg": 52,
	"./image-intro-mobile.jpg": 13,
	"./logo.svg": 8
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10;